import axios from 'axios';
import authHeader from '../../auth-header';

import tokenHeader from '../../token-header';

import baseUrl from '../../base-url';

const API_URL = baseUrl() + "/api/all/";

const getDataPengajuan = 'pengajuan-skp';
const putDataPengajuan = 'pengajuan-skp/';
const deleteDataPengajuan = 'pengajuan-skp/';

class PengajuanSkpPesertaService {
    getDataPengajuan(
        currentPage,
        pageSize,
        filter,
        tahun
    ) {
        var data = {
            pageNo: currentPage,
            pageSize: pageSize,
            filter: filter,
            tahun: tahun,
            jenis_pengajuan : 'tidak_terstruktur'
        }
        return axios.get(
            API_URL + getDataPengajuan,
            {
                params: data,
                headers: authHeader()
            });
    }

    exportPengajuanSkp(jenis,tahun) {
        return axios.get(API_URL + 'pengajuan-skp-export/jenis/'+jenis+'/tahun/'+tahun, {
            headers: authHeader(),
            responseType: 'blob',
        });
    }

    getDataPengajuanTidakTerstrukturKeStruktur(
        currentPage,
        pageSize,
        filter,
        tahun
    ) {
        var data = {
            pageNo: currentPage,
            pageSize: pageSize,
            filter: filter,
            tahun: tahun,
            jenis_pengajuan : 'tidak_terstruktur_ke_struktur'
        }
        return axios.get(
            API_URL + getDataPengajuan,
            {
                params: data,
                headers: authHeader()
            });
    }

    putDataPengajuan(formData) {       
        var form = {
            statusPengajuan : formData.status_pengajuan,
            jenisPengajuan : formData.jenis_pengajuan ,
            skpDiterima : formData.skp_diterima,
            keterangan : formData.keterangan,
            idKatalog : formData.id_katalog,
        } 
        return axios.put(API_URL + putDataPengajuan + formData.id_pengajuan_skp, 
            form,
        {
            headers: authHeader() 
        });
    }

    deleteDataPengajuan(formData) {        
        return axios.delete(API_URL + deleteDataPengajuan + formData.id_pengajuan_skp, 
        {
            headers: authHeader() 
        });
    }


}

export default new PengajuanSkpPesertaService();